var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/SellBlockInfo/SellBlockInfo.jinja"] = require( "front/components/SellBlockInfo/SellBlockInfo.jinja" );
dependencies["front/components/Objects/Objects.jinja"] = require( "front/components/Objects/Objects.jinja" );
dependencies["front/components/Feedbacks/Feedbacks.jinja"] = require( "front/components/Feedbacks/Feedbacks.jinja" );
dependencies["front/components/Discount/Discount.jinja"] = require( "front/components/Discount/Discount.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/ServiceCommon/ServiceCommonPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/ServiceCommon/ServiceCommonPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/SellBlockInfo/SellBlockInfo.jinja", false, "assets/app/front/pages/ServiceCommon/ServiceCommonPopup.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SellBlockInfo")) {
var t_7 = t_4.SellBlockInfo;
} else {
cb(new Error("cannot import 'SellBlockInfo'")); return;
}
context.setVariable("SellBlockInfo", t_7);
output += "\n";
env.getTemplate("front/components/Objects/Objects.jinja", false, "assets/app/front/pages/ServiceCommon/ServiceCommonPopup.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "Objects")) {
var t_11 = t_8.Objects;
} else {
cb(new Error("cannot import 'Objects'")); return;
}
context.setVariable("Objects", t_11);
output += "\n";
env.getTemplate("front/components/Feedbacks/Feedbacks.jinja", false, "assets/app/front/pages/ServiceCommon/ServiceCommonPopup.jinja", false, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
t_12.getExported(function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
if(Object.prototype.hasOwnProperty.call(t_12, "Feedbacks")) {
var t_15 = t_12.Feedbacks;
} else {
cb(new Error("cannot import 'Feedbacks'")); return;
}
context.setVariable("Feedbacks", t_15);
output += "\n\n<div class=\"ServiceCommonPopup Service\">\n    <div class=\"Service-headerWrapper\">\n        <h1 class=\"Service-header\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ServiceCommon")),"title"), env.opts.autoescape);
output += "</h1>\n        <a class=\"Service-close u-Route\" href=\"";
output += runtime.suppressValue((lineno = 8, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:index"])), env.opts.autoescape);
output += "\">\n            ";
output += runtime.suppressValue((lineno = 9, colno = 36, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["x",runtime.makeKeywordArgs({"caller": (function (){var macro_t_16 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_17 = "";;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
return macro_t_16;})()})])), env.opts.autoescape);
output += "\n        </a>\n    </div>\n    <div class=\"Service-content Service-block Service-body\">\n        <div class=\"Service-desc Service-text\">\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ServiceCommon")),"text"), env.opts.autoescape);
output += "\n        </div>\n\n        ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "objects"))) {
output += "\n            <div class=\"Service-blockItem Service-blockItem--objects\">\n                ";
output += runtime.suppressValue((lineno = 19, colno = 26, runtime.callWrap(t_11, "Objects", context, [runtime.makeKeywordArgs({"objects": runtime.contextOrFrameLookup(context, frame, "objects"),"button_text": "объектов в продаже","btn_type": "button","isMobile": (lineno = 19, colno = 114, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isMobile"), "isMobile", context, [runtime.contextOrFrameLookup(context, frame, "request")]))})])), env.opts.autoescape);
output += "\n            </div>\n        ";
;
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ServiceCommon")),"help")) {
output += "\n            <h2 class=\"Service-blockTitle\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ServiceCommon")),"help")),"title"), env.opts.autoescape);
output += "</h2>\n\n            ";
frame = frame.push();
var t_20 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ServiceCommon")),"help")),"items");
if(t_20) {t_20 = runtime.fromIterator(t_20);
var t_19 = t_20.length;
for(var t_18=0; t_18 < t_20.length; t_18++) {
var t_21 = t_20[t_18];
frame.set("item", t_21);
frame.set("loop.index", t_18 + 1);
frame.set("loop.index0", t_18);
frame.set("loop.revindex", t_19 - t_18);
frame.set("loop.revindex0", t_19 - t_18 - 1);
frame.set("loop.first", t_18 === 0);
frame.set("loop.last", t_18 === t_19 - 1);
frame.set("loop.length", t_19);
output += "\n                ";
output += runtime.suppressValue((lineno = 27, colno = 32, runtime.callWrap(t_7, "SellBlockInfo", context, [runtime.makeKeywordArgs({"block": t_21,"isNumber": runtime.memberLookup((t_21),"isNumber")})])), env.opts.autoescape);
output += "\n            ";
;
}
}
frame = frame.pop();
output += "\n        ";
;
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ServiceCommon")),"extraHelp")) {
output += "\n            <h2 class=\"Service-blockTitle\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ServiceCommon")),"extraHelp")),"title"), env.opts.autoescape);
output += "</h2>\n\n            ";
frame = frame.push();
var t_24 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ServiceCommon")),"extraHelp")),"items");
if(t_24) {t_24 = runtime.fromIterator(t_24);
var t_23 = t_24.length;
for(var t_22=0; t_22 < t_24.length; t_22++) {
var t_25 = t_24[t_22];
frame.set("item", t_25);
frame.set("loop.index", t_22 + 1);
frame.set("loop.index0", t_22);
frame.set("loop.revindex", t_23 - t_22);
frame.set("loop.revindex0", t_23 - t_22 - 1);
frame.set("loop.first", t_22 === 0);
frame.set("loop.last", t_22 === t_23 - 1);
frame.set("loop.length", t_23);
output += "\n                ";
output += runtime.suppressValue((lineno = 35, colno = 32, runtime.callWrap(t_7, "SellBlockInfo", context, [runtime.makeKeywordArgs({"block": t_25,"isNumber": runtime.memberLookup((t_25),"isNumber")})])), env.opts.autoescape);
output += "\n            ";
;
}
}
frame = frame.pop();
output += "\n        ";
;
}
output += "\n\n        <div class=\"Service-blockItem Service-blockItem--discount\">\n            ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/Discount/Discount.jinja", false, "assets/app/front/pages/ServiceCommon/ServiceCommonPopup.jinja", false, function(t_27,t_26) {
if(t_27) { cb(t_27); return; }
callback(null,t_26);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_29,t_28) {
if(t_29) { cb(t_29); return; }
callback(null,t_28);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n        </div>\n\n        ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "feedbacks"))) {
output += "\n            <div class=\"Service-blockItem Service-blockItem--feedbacks\">\n                ";
output += runtime.suppressValue((lineno = 45, colno = 28, runtime.callWrap(t_15, "Feedbacks", context, [runtime.makeKeywordArgs({"feedbacks": runtime.contextOrFrameLookup(context, frame, "feedbacks"),"button_text": "отзывов","isMobile": (lineno = 45, colno = 90, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isMobile"), "isMobile", context, [runtime.contextOrFrameLookup(context, frame, "request")]))})])), env.opts.autoescape);
output += "\n            </div>\n        ";
;
}
output += "\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/ServiceCommon/ServiceCommonPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/ServiceCommon/ServiceCommonPopup.jinja
// module id = 98
// module chunks = 0